import { render, staticRenderFns } from "./move-dialog.vue?vue&type=template&id=34889c7a&scoped=true"
import script from "./move-dialog.vue?vue&type=script&lang=ts"
export * from "./move-dialog.vue?vue&type=script&lang=ts"
import style0 from "./move-dialog.vue?vue&type=style&index=0&id=34889c7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34889c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34889c7a')) {
      api.createRecord('34889c7a', component.options)
    } else {
      api.reload('34889c7a', component.options)
    }
    module.hot.accept("./move-dialog.vue?vue&type=template&id=34889c7a&scoped=true", function () {
      api.rerender('34889c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/partials/move-dialog.vue"
export default component.exports